import { jsx as _jsx } from "react/jsx-runtime";
import ImageRepository from './VitualizedChat/ImageRepository';
import { Message } from '.';
const messageRender = ({ accountId, isThread = false, handleReaction, setThread, getIconFromCache, openMobileReactions, setOpenMobileReactions, toggleEmojiSelector, editable, onEditModeRequested, onEditModeCancelled, onMessageUpdated, deleteable, onDeleteMessageRequested, fetchAccounts, autocompleteAccounts, authToken, privateIpfsEndpoint, }) => {
    const store = new ImageRepository(getIconFromCache);
    const openThread = (message) => {
        if (!isThread && setThread) {
            setThread(message);
        }
    };
    const toggleReaction = (message, reaction) => {
        handleReaction(message, reaction);
    };
    const handleEmojiSelector = (message) => {
        toggleEmojiSelector(message);
    };
    const renderMessage = (message, prevMessage) => {
        return (_jsx(Message, { message: message, prevMessage: prevMessage, accountId: accountId, openThread: () => openThread(message), handleReaction: (reaction) => toggleReaction(message, reaction), isThread: isThread, getIconFromCache: (id) => store.getCacheImage(id), toggleEmojiSelector: () => handleEmojiSelector(message), openMobileReactions: openMobileReactions, setOpenMobileReactions: (id) => setOpenMobileReactions(id), editable: editable(message), deletable: deleteable(message), editMessage: () => onEditModeRequested(message, isThread), cancelEditMessage: () => onEditModeCancelled(message), submitEditedMessage: (text) => onMessageUpdated(Object.assign(Object.assign({}, message), { text })), deleteMessage: () => onDeleteMessageRequested(message), fetchAccounts: fetchAccounts, autocompleteAccounts: autocompleteAccounts, authToken: authToken, privateIpfsEndpoint: privateIpfsEndpoint }));
    };
    return renderMessage;
};
export default messageRender;
